import React from 'react'
import { SocialIcon } from 'react-social-icons'

const Follow = () => {
    return (    
        <div style={{ width: `30vw`, display: `flex`, justifyContent: `space-evenly` }}>
            <SocialLink url="https://twitter.com/@dangoslen" />
            <SocialLink url="https://dangoslen.medium.com" />
            <SocialLink url="https://linkedin.com/in/dangoslen" />
            <SocialLink url="https://dangoslen.me" />
        </div>
    )
}

const SocialLink = ({ url }) => {
    return (
        <SocialIcon url={ url } bgColor='#f1935c' /> 
    )
}

export default Follow